// React Native Web 全局 shims - 必须在任何导入之前
console.log('🚀 [Web] 开始初始化应用...');
console.log('🚀 [Web] 当前时间:', new Date().toISOString());

if (typeof window !== 'undefined') {
    console.log('🚀 [Web] 设置全局 shims...');
    // 定义 React Native 桥接配置
    window.__fbBatchedBridgeConfig = {
        remoteModuleConfig: [],
        localModulesConfig: []
    };
    
    // 定义全局的原生模块 shims
    window.NativeModules = {};
    window.TurboModuleRegistry = {
        getEnforcing: () => null,
        get: () => null
    };
    window.NativeDeviceInfo = {
        getConstants: () => ({})
    };
    
    // WebView 相关的全局变量
    window.NativeWebViewMacOSBase = {};
    window.NativeWebViewIOSBase = {};
    window.NativeWebViewAndroidBase = {};
    console.log('✅ [Web] 全局 shims 设置完成');
}

console.log('📦 [Web] 开始导入核心模块...');

// 先导入 React 和 ReactDOM
import React from 'react';
import { createRoot } from 'react-dom/client';
console.log('✅ [Web] React 和 ReactDOM 导入成功');

// 导入 React Native 基础组件
import { AppRegistry } from 'react-native';
console.log('✅ [Web] AppRegistry 导入成功');

// 导入桌面端样式（必须在其他导入之前）
console.log('📦 [Web] 准备导入 DesktopStyles...');
import { injectDesktopStyles } from '../src/utils/DesktopStyles';
console.log('✅ [Web] DesktopStyles 导入成功');

// 导入最简单的测试页面
console.log('📦 [Web] 准备导入 Providers...');
import { Providers } from '../src/screen/Providers';
console.log('✅ [Web] Providers 导入成功，类型:', typeof Providers);

const appName = 'bee_chat';
console.log('📱 [Web] 应用名称:', appName);

// Web平台特定配置
if (typeof window !== 'undefined') {
    // 允许在输入框区域拖拽，但阻止默认的浏览器打开文件行为
    window.addEventListener('dragover', (e) => {
        // 只在非输入框区域阻止默认行为
        const target = e.target;
        if (target && (target.tagName === 'TEXTAREA' || target.tagName === 'INPUT')) {
            // 允许在输入框区域拖拽
            return;
        }
        e.preventDefault();
    });
    
    window.addEventListener('drop', (e) => {
        // 只在非输入框区域阻止默认行为
        const target = e.target;
        if (target && (target.tagName === 'TEXTAREA' || target.tagName === 'INPUT')) {
            // 允许在输入框区域拖拽
            return;
        }
        e.preventDefault();
    });
}

// 在Web上运行应用
if (typeof document !== 'undefined') {
    console.log('🌐 [Web] 准备运行应用...');
    
    const initApp = () => {
        // 注入桌面端样式
        console.log('🎨 [Web] 注入桌面端样式...');
        injectDesktopStyles();
        console.log('✅ [Web] 桌面端样式注入完成');
        
        const rootElement = document.getElementById('root');
        console.log('🔍 [Web] Root 元素:', rootElement);
        
        if (!rootElement) {
            console.error('❌ [Web] 找不到 root 元素！');
            document.body.innerHTML = '<div style="padding: 20px; color: red;">错误: 找不到 root 元素</div>';
            return;
        }
        
        // 确保 root 元素有正确的样式
        rootElement.style.height = '100vh';
        rootElement.style.width = '100vw';
        rootElement.style.display = 'flex';
        rootElement.style.flexDirection = 'column';
        rootElement.style.backgroundColor = '#ffffff';
        
        try {
            console.log('🚀 [Web] 开始渲染 React 应用...');
            console.log('🚀 [Web] Providers 类型:', typeof Providers);
            
            if (!Providers) {
                throw new Error('Providers 组件未定义');
            }
            
            // 使用 ReactDOM 直接渲染
            const root = createRoot(rootElement);
            const element = React.createElement(Providers);
            root.render(element);
            
            console.log('✅ [Web] React 应用渲染成功！');
            
            // 延迟检查渲染结果
            setTimeout(() => {
                if (rootElement.children.length === 0) {
                    console.warn('⚠️ [Web] Root 元素没有子节点！');
                } else {
                    console.log('✅ [Web] 页面已成功渲染，子节点数量:', rootElement.children.length);
                }
            }, 500);
            
        } catch (error) {
            console.error('❌ [Web] 应用启动失败:', error);
            console.error('❌ [Web] 错误堆栈:', error.stack);
            rootElement.innerHTML = `<div style="padding: 20px; color: red; font-family: monospace;">
                <h2>应用启动失败</h2>
                <p><strong>错误:</strong> ${error.message}</p>
                <details>
                    <summary>错误堆栈</summary>
                    <pre style="overflow: auto; max-height: 300px;">${error.stack}</pre>
                </details>
            </div>`;
        }
    };
    
    // 等待 DOM 准备好
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initApp);
    } else {
        // DOM 已经加载完成，延迟一点确保所有脚本都加载完成
        setTimeout(initApp, 50);
    }
} else {
    console.error('❌ [Web] document 未定义！');
}
